export const FULL_DATETIME_TIMEZONE = 'dd/MM/yyyy HH:mm:ss:SSS zzzz';
export const FULL_DATETIME = 'dd/MM/yyyy HH:mm:ss';
export const DATETIME_WITHOUT_SECONDS = 'dd/MM/yyyy HH:mm';
export const ONLY_DATE = 'dd/MM/yyyy';
export const YEAR_FIRST_DATE = 'yyy-MM-dd';
